import * as mutationTypes from './types/mutation_types';
import * as actionsTypes from './types/action_types';
import * as getterTypes from './types/getter_types';

import {
  deleteIngredient,
  fetchIngredients,
  fetchIngredientCategories,
  storeIngredient,
  updateIngredient,
} from '../services/ingredients';

export default {
  async [actionsTypes.FETCH_INGREDIENTS]({ commit }, options) {
    commit(mutationTypes.INGREDIENTS_REQUEST);
    const result = await fetchIngredients(options).catch((e) => {
      commit(mutationTypes.INGREDIENTS_ERROR, e);
    });
    if (result) {
      commit(mutationTypes.INGREDIENTS_SUCCESS, result);
    }
    return result;
  },
  async [actionsTypes.FETCH_INGREDIENT_CATEGORY]({ commit }, options) {
    const result = await fetchIngredientCategories(options).catch((e) => {
      commit(mutationTypes.INGREDIENTS_ERROR, e);
    });
    if (result) {
      commit(mutationTypes.INGREDIENTS_CATEGORY, result.data);
    }
    return result;
  },
  async [actionsTypes.STORE_INGREDIENT]({ commit, getters }, payload) {
    commit(mutationTypes.INGREDIENTS_REQUEST);
    const result = await storeIngredient(payload).catch((e) => {
      commit(mutationTypes.INGREDIENTS_ERROR, e);
    });
    if (result) {
      const categories = getters[getterTypes.DATA];
      categories.data.push(result.data);
      commit(mutationTypes.INGREDIENTS_SUCCESS, categories);
    }
    return result;
  },
  async [actionsTypes.UPDATE_INGREDIENT]({ commit, getters }, payload) {
    commit(mutationTypes.INGREDIENTS_REQUEST);
    await updateIngredient(payload.id, payload).catch((e) => {
      commit(mutationTypes.INGREDIENTS_ERROR, e);
    });
    commit(mutationTypes.INGREDIENTS_SUCCESS, getters[getterTypes.DATA]);
  },
  async [actionsTypes.DELETE_INGREDIENT]({ commit, getters }, id) {
    commit(mutationTypes.INGREDIENTS_REQUEST);
    const result = await deleteIngredient(id).catch((e) => {
      commit(mutationTypes.INGREDIENTS_ERROR, e);
    });
    if (result) {
      const categories = getters[getterTypes.DATA];
      categories.data = categories.data.filter((branch) => branch.id !== id);
      commit(mutationTypes.INGREDIENTS_SUCCESS, categories);
    }
    return result;
  },
  [actionsTypes.SELECT_INGREDIENT]({ commit }, payload) {
    commit(mutationTypes.INGREDIENTS_SELECT, payload);
  },
  [actionsTypes.SELECT_INGREDIENT_RESET]({ commit }) {
    commit(mutationTypes.INGREDIENTS_SELECT_RESET);
  },
};
